import theme, { Colors } from '@qnpm/q-theme';
import { StyleSheet } from 'react-native';
const { scenes: { baseColor } } = Colors;
const { font, layout, responsive: { scale } } = theme;
const { label: labelLayout } = layout;
class Style {
    constructor(isScale, isBgGradient, size) {
        // 获取样式
        this.getStyle = () => {
            const { paddingHorizontal, height, minWidth } = this.layoutSize;
            // 容器基本样式
            const baseWrapperStyle = {
                height: this.labelHeight,
                paddingHorizontal: paddingHorizontal.small,
                backgroundColor: baseColor.brand,
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                overflow: 'hidden'
            };
            const baseTextStyle = {
                fontSize: this.labelTextSize,
                color: baseColor.white,
                fontWeight: 'normal',
                textAlignVertical: 'center',
                // 标签不会展示上标/下标，删除额外的padding，使文字保持居中
                includeFontPadding: false
            };
            const splitStyle = {
                height: height.mini,
                width: 0,
                borderLeftWidth: StyleSheet.hairlineWidth,
                marginHorizontal: paddingHorizontal.small,
                borderColor: baseColor.brandText
            };
            // 填充类样式: basic
            const fillBasicStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: 2, minWidth: minWidth.small }),
                textStyle: baseTextStyle
            };
            // 填充类样式: 全角
            const fillWholeStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: scale(8, this.isScale), paddingHorizontal: paddingHorizontal.medium, minWidth: minWidth.large }),
                textStyle: baseTextStyle
            };
            // 边框类样式
            const borderStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: 2, borderWidth: StyleSheet.hairlineWidth, borderColor: baseColor.brandText, backgroundColor: 'transparent', minWidth: minWidth.small, overflow: 'hidden' }),
                textStyle: Object.assign(Object.assign({}, baseTextStyle), { color: baseColor.brandText }),
                splitStyle: splitStyle
            };
            // 组合类样式
            const combineStyle = {
                wrapperLeftStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderTopLeftRadius: 2, borderBottomLeftRadius: 2, borderColor: baseColor.brandText, borderWidth: StyleSheet.hairlineWidth, borderRightWidth: 0 }),
                wrappeRightStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderTopRightRadius: 2, borderBottomRightRadius: 2, borderColor: baseColor.brandText, borderWidth: StyleSheet.hairlineWidth, borderLeftWidth: 0, backgroundColor: 'transparent' }),
                textLeftStyle: baseTextStyle,
                textRightStyle: Object.assign(Object.assign({}, baseTextStyle), { color: baseColor.brandText }),
                splitStyle: splitStyle
            };
            // 气泡类样式: top
            const angleBasicStyle = {
                wrapperStyle: Object.assign(Object.assign(Object.assign({}, baseWrapperStyle), { borderBottomRightRadius: scale(8, this.isScale), paddingHorizontal: paddingHorizontal.small, minWidth: minWidth.medium }), this.borderColor),
                textStyle: baseTextStyle
            };
            // 角标类样式: notice
            const angleFullStyle = {
                wrapperStyle: Object.assign(Object.assign(Object.assign({}, baseWrapperStyle), { backgroundColor: baseColor.text1, paddingHorizontal: this.labelAngleFullPadding, height: this.labelAngleFullHeight, borderTopRightRadius: scale(9, this.isScale), borderBottomRightRadius: scale(9, this.isScale), minWidth: minWidth.medium }), this.borderColor),
                textStyle: baseTextStyle
            };
            return {
                fillBasicStyle,
                fillWholeStyle,
                borderStyle,
                combineStyle,
                angleBasicStyle,
                angleFullStyle
            };
        };
        this.isScale = !!isScale;
        this.isBgGradient = !!isBgGradient;
        this.fontSize = isScale ? font.size.scaled : font.size.unscaled;
        this.layoutSize = isScale ? labelLayout.scaled : labelLayout.unscaled;
        this.labelSize = size || 'medium';
        this.borderColor = this.isBgGradient
            ? {
                borderColor: 'transparent',
                overflow: 'hidden',
                backgroundColor: 'transparent'
            }
            : {};
    }
    /**
     * 根据大小设置字号
     */
    get labelTextSize() {
        const sizeConfig = {
            medium: this.fontSize.fontSizeXS,
            small: scale(9, this.isScale)
        };
        return sizeConfig[this.labelSize] || sizeConfig.medium;
    }
    /**
     * 根据大小设置高度
     */
    get labelHeight() {
        const { height } = this.layoutSize;
        return height[this.labelSize] || height.medium;
    }
    /**
     * 全角标高度 - 与其他的不一样
     */
    get labelAngleFullHeight() {
        const { height } = this.layoutSize;
        const heightConfig = {
            medium: height.large,
            small: height.medium
        };
        return heightConfig[this.labelSize] || heightConfig.medium;
    }
    /**
     * 全角标padding - 与其他的不一样
     */
    get labelAngleFullPadding() {
        const { paddingHorizontal } = this.layoutSize;
        const paddingConfig = {
            medium: paddingHorizontal.large,
            small: paddingHorizontal.medium
        };
        return paddingConfig[this.labelSize] || paddingConfig.medium;
    }
    /**
     * 获取splite padding值
     */
    get spliteMargin() {
        const { paddingHorizontal } = this.layoutSize;
        return paddingHorizontal.small;
    }
}
export default Style;
